import { ItemVM } from 'shell/view-models/item';

export default function filterParenthood(
  parenthood: ItemVM,
  isHeadMarriage: boolean,
  isHeadParenthood: boolean
): boolean {
  const code = parenthood.id?.toString();

  if (
    code === '25' ||
    code === '13' ||
    code === '22' ||
    code === '11' ||
    code === '24' ||
    code === '4' ||
    code === '20' ||
    code === '10'
  ) {
    return false;
  }

  if (isHeadParenthood && isHeadMarriage) {
    return code !== '1' && code !== '2';
  }

  if (isHeadParenthood) {
    return code !== '1';
  }

  if (isHeadMarriage) {
    return code !== '2';
  }

  return true;
}
